import React from "react";
import "../styles/cookie-banner.css";

export default function CookieBanner() {
  const [ok, setOk] = React.useState(
    () => localStorage.getItem("cookie-ok") === "1"
  );
  if (ok) return null;

  const accept = () => {
    localStorage.setItem("cookie-ok", "1");
    setOk(true);
  };

  return (
    <div
      className="cookie-wrap"
      role="dialog"
      aria-live="polite"
      aria-label="Sütikezelés"
    >
      <div className="cookie-text">
        A weboldal sütiket használ a jobb felhasználói élmény és működés
        érdekében. További információ az{" "}
        <a href="/privacy" className="cookie-link">
          Adatkezelési tájékoztatóban
        </a>
        .
      </div>

      <div className="cookie-actions">
        <button className="cookie-btn-outline" onClick={() => setOk(true)}>
          Elutasítom
        </button>
        <button className="cookie-btn-brand" onClick={accept}>
          Elfogadom
        </button>
      </div>
    </div>
  );
}
